import { render, staticRenderFns } from "./sys-sidebar.vue?vue&type=template&id=54ce3892&scoped=true"
import script from "./sys-sidebar.vue?vue&type=script&lang=js"
export * from "./sys-sidebar.vue?vue&type=script&lang=js"
import style0 from "./sys-sidebar.vue?vue&type=style&index=0&id=54ce3892&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce3892",
  null
  
)

export default component.exports